import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronDown, Globe } from 'lucide-react';
import { companyInfo } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { label: language === 'tr' ? 'Biz' : 'About Us', href: '#about', hasDropdown: false },
    { label: language === 'tr' ? 'Servislerimiz' : 'Our Services', href: '#services', hasDropdown: false },
    { label: language === 'tr' ? 'Sektörler' : 'Sectors', href: '#sectors', hasDropdown: true },
    { label: language === 'tr' ? 'Sürdürülebilirlik' : 'Sustainability', href: '#sustainability', hasDropdown: true },
    { label: language === 'tr' ? 'İletişim' : 'Contact', href: '#contact', hasDropdown: false }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#36344D] shadow-lg py-2' : 'bg-[#36344D]/95 py-4'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#home" className="flex items-center space-x-2">
            <img
              src={companyInfo.logo}
              alt="Movent Logistics"
              className="h-20 lg:h-24 w-auto object-contain"
            />
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            {menuItems.map((item, index) => (
              <div key={index} className="relative group">
                <a
                  href={item.href}
                  className="text-white hover:text-[#DF6A6A] transition-colors duration-300 flex items-center space-x-1 text-sm font-medium"
                >
                  <span>{item.label}</span>
                  {item.hasDropdown && <ChevronDown className="w-4 h-4" />}
                </a>
              </div>
            ))}
          </div>

          {/* Right Side - Language & Contact */}
          <div className="hidden lg:flex items-center space-x-4">
            <button 
              onClick={toggleLanguage}
              className="flex items-center space-x-2 text-white hover:text-[#DF6A6A] transition-colors px-3 py-2 rounded-md border border-white/20 hover:border-[#DF6A6A]"
            >
              <Globe className="w-5 h-5" />
              <span className="text-sm font-medium">{language.toUpperCase()}</span>
            </button>
            <a
              href="#contact"
              className="bg-[#DF6A6A] text-white px-6 py-2 rounded-md hover:bg-[#c55555] transition-colors duration-300 font-medium"
            >
              {language === 'tr' ? 'İletişim' : 'Contact'}
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white hover:text-[#DF6A6A] transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-white/20">
            <div className="flex flex-col space-y-4 mt-4">
              {menuItems.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  className="text-white hover:text-[#DF6A6A] transition-colors text-base font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <button 
                onClick={() => {
                  toggleLanguage();
                  setIsMobileMenuOpen(false);
                }}
                className="flex items-center space-x-2 text-white hover:text-[#DF6A6A] transition-colors text-base font-medium"
              >
                <Globe className="w-5 h-5" />
                <span>{language === 'tr' ? 'English' : 'Türkçe'}</span>
              </button>
              <a
                href="#contact"
                className="bg-[#DF6A6A] text-white px-6 py-2 rounded-md hover:bg-[#c55555] transition-colors text-center font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {language === 'tr' ? 'İletişim' : 'Contact'}
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;